// extracted by mini-css-extract-plugin
export default {"button":"FloatingCookieButton_button__Rdp+6","icon":"FloatingCookieButton_icon__ttqeY"};